module.exports = __webpack_public_path__ + "static/media/paymentPage_orderedCharged.e0192ec5.png";